import CamelCase from 'camelcase-keys'
import * as uuid from 'uuid'

export const sequenceEqual = (array1?: any[], array2?: any[]): boolean => {
    if (!array1) array1 = []
    if (!array2) array2 = []

    return (array1.filter((x: any) => array2!.some(y => x !== y)).length ?? 0) === 0
}

export const replaceNullValues = <T extends object>(obj: T, replacement: any = '') => {
    Object.entries(obj).forEach(([key, value]) => {
        const k = key as keyof T
        if (value === null) (obj)[k] = replacement
        else obj[k] = value
    })

    return obj
}

// az se bude refaktorovat datepicker na react-datepicker, tak vsechna pouziti smazat
export function dateToString(date: Date) {
    const local = new Date(date)
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset())
    return local.toJSON().slice(0, 10)
}

// konverze mvc ModelState do objektu (používající třeba formik.errors)
// např: PolicyHolder.Address.StreetNumber='validation message' -> PolicyHolder: { Address: { StreetNumber='validation message'}}
export function modelStateToJson(modelstate: any): any {
    let formikErr: any = {}
    for (const prop in modelstate) {
        formikErr = makeObj(formikErr, prop, modelstate[prop][0])
    }

    return CamelCase(formikErr, { deep: true })
}

const makeObj = (obj: any, prop: string, errorMessage: string): any => {
    const keyArr: string[] = prop.split('.')
    if (keyArr.length === 1) {
        obj[prop] = errorMessage
    }
    else {
        const pr = keyArr.shift()!
        obj[pr] = obj[pr] ?? {}
        obj[pr] = makeObj(obj[pr], keyArr.join('.'), errorMessage)
    }

    return obj
}

// camel case pro pripad cesty k property nested objektu 
// např.PolicyHolder.Address.StreetNumber -> policyHolder.address.streetNumber
export function toCamelCase(key: string) {
    return key
        .split('.')
        .map((keyPart: string) => camelize(keyPart))
        .join('.') as any
}

export function camelize(str: string) {
    // oddeleni po slovech. Prvni slovo zacina malym, ostatni velkym
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase()
    }).replace(/\s+/g, '')
}

export function pascalize(str: string) {
    // oddeleni po slovech. Vsechny slova zacina velkym
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word) {
        return word.toUpperCase()
    }).replace(/\s+/g, '')
}

export const padLeft = (source: string, length: number, character: string = '0'): string => {
    for (let i = source.length; i < length; ++i) {
        source = character + source
    }

    return source
}

export const getNameOfEnumKey = (enumObj: any, enumValue: any) => {
    const keys = Object.keys(enumObj).filter(x => enumObj[x] === enumValue)
    return keys.length > 0 ? keys[0] : ''
}

export const newUid = () => {
    return uuid.v4()
}